import { IDataroomListItem } from './vo/DataroomListItem';

export default class DataroomListItem {
  static isDataroomDisabled(vo: IDataroomListItem): boolean {
    const { isDeactivated } = vo;
    const isAccessRequestPending = vo.accessRequest?.isPending;
    const isAccessRequestDenied = vo.accessRequest?.isDenied;
    return isAccessRequestPending || isAccessRequestDenied || isDeactivated;
  }
}
